import { Table } from "antd";
import { get, toLower } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/ducks/Loading";
import { dbMonthLg, langMonth } from "../../../utils/properties";
import { formatNumber, showError } from "../../../utils/utilities";
import AccountingBookPlanning from "../../../services/api/AccountingBookPlanning";
import dayjs from "dayjs";

const Progressive = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const [state, setState] = useState({
    tableContent: [],
    loading: false,
  });

  useEffect(() => {
    if (filters.obj?.year) {
      dataList(filters.obj?.year);
    }
  }, [filters]);

  const dataList = async (year) => {
    dispatch(setLoading(true));
    const { data, error } = await AccountingBookPlanning.getProgressive(year);
    if (!error && data) {
      setState((prevState) => ({
        ...prevState,
        tableContent: data || [],
      }));
    } else {
      showError(get(error, "messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const columns = [
    {
      title: t("lg.table.yearMonth"),
      dataIndex: "yearMonth",
      key: "yearMonth",
      render: (yearMonth) =>
        yearMonth !== null ? dayjs(yearMonth.toString(), dbMonthLg).format(langMonth[toLower(currentLanguage)]) : "-",
    },
    {
      title: t("lg.table.amountDebitMonth"),
      dataIndex: "amountDebitMonth",
      key: "amountDebitMonth",
      className: "table-value-right",
      render: (amountDebitMonth) =>
        formatNumber({ value: amountDebitMonth, suffix: "EUR", lang: currentLanguage, decimalScale: 2 }),
    },
    {
      title: t("lg.table.amountCreditMonth"),
      dataIndex: "amountCreditMonth",
      key: "amountCreditMonth",
      className: "table-value-right",
      render: (amountCreditMonth) =>
        formatNumber({ value: amountCreditMonth, suffix: "EUR", lang: currentLanguage, decimalScale: 2 }),
    },
    {
      title: t("lg.table.amountDebitYear"),
      dataIndex: "amountDebitYear",
      key: "amountDebitYear",
      className: "table-value-right",
      render: (amountDebitYear) =>
        formatNumber({ value: amountDebitYear, suffix: "EUR", lang: currentLanguage, decimalScale: 2 }),
    },
    {
      title: t("lg.table.amountCreditYear"),
      dataIndex: "amountCreditYear",
      key: "amountCreditYear",
      className: "table-value-right",
      render: (amountCreditYear) =>
        formatNumber({ value: amountCreditYear, suffix: "EUR", lang: currentLanguage, decimalScale: 2 }),
    },
    {
      title: t("lg.table.sequenceNumberMonth"),
      dataIndex: "sequenceNumberMonth",
      key: "sequenceNumberMonth",
      className: "table-value-right",
    },
    {
      title: t("lg.table.totalPagesMonth"),
      dataIndex: "totalPagesMonth",
      key: "totalPagesMonth",
      className: "table-value-right",
    },
    {
      title: t("lg.table.lastPageMonth"),
      dataIndex: "lastPageMonth",
      key: "lastPageMonth",
      className: "table-value-right",
    },
    {
      title: t("lg.table.status"),
      dataIndex: "status",
      key: "status",
      render: (status) => t(`lg.status.${status}`),
    },
  ];

  return (
    <Table
      rowKey={(item) => item.yearMonth}
      dataSource={state.tableContent}
      loading={state.loading}
      columns={columns}
      size="small"
      pagination={false}
    />
  );
};

export default Progressive;
